module.exports = __webpack_public_path__ + "img/08.d4521702.jpg";